"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextButtonStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _edSystem = require("@eduact/ed-system");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TextButtonStyled = _styledComponents["default"].button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding: 1.125rem 2rem;\n\tfont-weight: 500;\n\tfont-size: ", ";\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\t/* font-size: 0.75rem; */\n\ttransition: all ease-in-out 200ms;\n\tdisplay: flex;\n\talign-items: center;\n\t/* min-width: 9.375rem; */\n\twhite-space: pre;\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n\t@media (min-width: 1024px) {\n\t\t", "\n\t}\n\n\t", "\n\t", "\n  ", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (props) {
  var _props$theme$fontSize, _props$theme$fontSize2;
  return "".concat((_props$theme$fontSize = (_props$theme$fontSize2 = props.theme.fontSizesAliases) === null || _props$theme$fontSize2 === void 0 ? void 0 : _props$theme$fontSize2.body) !== null && _props$theme$fontSize !== void 0 ? _props$theme$fontSize : 1, "rem");
}, (0, _styledSystem.variant)({
  prop: 'btnSize',
  scale: 'buttonSizes'
}), (0, _styledSystem.variant)({
  prop: 'btnSize',
  scale: 'buttonSizes'
}), (0, _styledSystem.variant)({
  scale: 'textButtonColors',
  prop: 'variant'
}), _styledSystem.textAlign, _styledSystem.flexbox, _styledSystem.typography, _edSystem.textDecoration, _styledSystem.space, _styledSystem.layout);
exports.TextButtonStyled = TextButtonStyled;